module.exports = __webpack_public_path__ + "media/svg/infantil-5481e246.svg";